
/* eslint-disable */
import { Message } from 'element-ui';

const errorMessage = (message) => {
  Message({
    message,
    type: 'error',
    duration: 4 * 1e3,
    showClose: true,
  });
};

/**
 * auth service handle global authrization.
 */
export default {
  response(res) {
    return res;
  },

  // global ajax error handler
  responseError(error) {
    // error reponse
    const { response = {} } = error;
    if (response.status) {
      switch (response.status) {
        case 401:
          errorMessage('401: Unauthorized');
          break;
        case 403:
          errorMessage('403: Forbidden');
          break;
        case 404:
          errorMessage('404: Not Found');
          break;
        default:
          errorMessage('servicse error, Please contact your administrator!');
      }
    };
    return Promise.reject(response).catch((response) => {
      errorMessage(error.message);
      console.log('catch:', error,response);
    });
  },
};
